module.exports = __webpack_public_path__ + "img/outdoor-fazer25.723a1389.jpg";